import { render, staticRenderFns } from "./WorkBookMenu.vue?vue&type=template&id=4074190a&scoped=true&"
import script from "./WorkBookMenu.vue?vue&type=script&lang=js&"
export * from "./WorkBookMenu.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookMenu.vue?vue&type=style&index=0&id=4074190a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074190a",
  null
  
)

export default component.exports